@switch (type) {
    @case ("flat") {
        <button
            type="button"
            mat-flat-button
            [attr.data-uiid]="dataUiid"
            [class]="[color, size]"
            [class.action]="isCallToAction"
            #buttonElement
            [disabled]="disabled"
            [matTooltip]="tooltipContent ?? ''"
            [matTooltipDisabled]="!tooltipContent"
        >
            <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
        </button>
    }
    @case ("stroked") {
        <button
            type="button"
            mat-stroked-button
            [attr.data-uiid]="dataUiid"
            [class]="[color, size]"
            [class.action]="isCallToAction"
            #buttonElement
            [disabled]="disabled"
            [matTooltip]="tooltipContent ?? ''"
            [matTooltipDisabled]="!tooltipContent"
        >
            <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
        </button>
    }
}

<ng-template #contentTemplate>
    <ng-content></ng-content>
</ng-template>
